import { Observable } from "core/Misc/observable";
/**
 * A collection of items that can be observed for changes.
 */
export class ObservableCollection {
    constructor() {
        this._items = [];
        this._keys = [];
        this._observable = new Observable();
    }
    /**
     * An observable that notifies observers when the collection changes.
     */
    get observable() {
        return this._observable;
    }
    /**
     * The items in the collection.
     */
    get items() {
        return this._items;
    }
    /**
     * Adds an item to the collection.
     * @param item The item to add.
     * @returns A disposable that removes the item from the collection when disposed.
     */
    add(item) {
        const key = Symbol();
        this._items.push(item);
        this._keys.push(key);
        this._observable.notifyObservers();
        return {
            dispose: () => {
                const index = this._keys.indexOf(key);
                this._items.splice(index, 1);
                this._keys.splice(index, 1);
                this._observable.notifyObservers();
            },
        };
    }
}
//# sourceMappingURL=observableCollection.js.map